import { useEffect, useRef } from "react";
import useAuth from "hooks/useAuth";
import { useDispatch } from "store";
import {
  failed,
  loaded,
  loading,
  reset,
} from "store/reducers/audienceTemplates";
import type { AudienceContentTemplateListItem } from "@foresting-tomorrow/api_types_firestore/dist/audienceContent";

/** Loads organisation templates once when an authenticated organisation becomes available. */
export default function AudienceTemplateLoader() {
  const { user, userOrg, listAudienceMapInformationTemplates } = useAuth();
  const dispatch = useDispatch();
  const loadedOrgId = useRef<string | null>(null);

  useEffect(() => {
    const orgId = userOrg?.id;
    if (!orgId || user?.authType === "anonymous") {
      loadedOrgId.current = null;
      dispatch(reset());
      return;
    }
    if (loadedOrgId.current === orgId) return;

    loadedOrgId.current = orgId;
    dispatch(loading(orgId));
    void listAudienceMapInformationTemplates()
      .then((templates) => {
        if (loadedOrgId.current === orgId) {
          dispatch(loaded({ orgId, templates }));
        }
      })
      .catch((error) => {
        console.error("Unable to load audience map templates", error);
        if (loadedOrgId.current === orgId) dispatch(failed(orgId));
      });
  }, [dispatch, listAudienceMapInformationTemplates, user?.authType, userOrg?.id]);

  return null;
}
